import Form from './Form';
import HasError from './components/HasError';

export default {
    install(Vue, options){   
        //console.log('Installing the Form plugin!');
        //Form;
        Vue.component('has-error', HasError);
    }
}